import { memo } from 'react';

import { useAvailablePeriods } from '@entities/available-periods';
import { useSchedules, useTz } from '@entities/schedules';

import { AvailableDaySession } from '../available-day-session';
import { BusyDaySession } from '../busy-day-session';
import { EmptyDaySession } from '../empty-day-session';
import * as st from './styles.module.scss';

interface DaySessionProps {
	start: Date;
	end: Date;
	onScheduleClick?: (id: number) => void;
}

export const DaySessionBlock: React.FC<DaySessionProps> = memo(
	({ start, end, onScheduleClick }) => {
		const { findSchedules } = useSchedules();
		const { findAvailable } = useAvailablePeriods();
		const { tz } = useTz();

		const availablePeriod = findAvailable({ start, end }, tz);
		const busyPeriod = findSchedules({ start, end }, tz);

		const onClick = () => {
			if (busyPeriod && onScheduleClick) onScheduleClick(busyPeriod.consultation_id);
		};

		return (
			<div className={st.day__session} id={start.toISOString()}>
				{availablePeriod && !busyPeriod && (
					<AvailableDaySession availableId={availablePeriod.id} start={start} end={end} />
				)}

				{busyPeriod && (
					<BusyDaySession start={start} end={end} scheduleId={busyPeriod.id} onClick={onClick} />
				)}

				{!availablePeriod && !busyPeriod && <EmptyDaySession start={start} end={end} />}
			</div>
		);
	}
);
